var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Center, FormControl, FormLabel, Input, Text, Button, FormHelperText } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { ScaleLoader } from 'react-spinners';
import { APPEvent } from '@/events/AppEvents';
import { Apphandler } from '@/ipc/MainAppHandler';
import { AppColor } from '../const/AppDefaults';
import { testIsMobile } from '@@/Util';
export class RegisterNewDeviceStore {
    constructor() {
        this.open = false;
        this.basedialogState = new BaseDialogState();
        this.devicecode = "";
        this.genertaing = false;
        this.error = "";
        this.appcode = "";
        this.appid = "";
        makeObservable(this);
        this.basedialogState.setHideFooter(true);
        this.basedialogState.setHeaderLabel("Register New Device");
        this.basedialogState.setDisableOkButton(true);
        APPEvent.addSubscriberForRegisterAnotherDevice((res) => {
            if (this.genertaing) {
                if (res === undefined) {
                    this.setError("Sorry, failed to create register codes. Please try again later");
                }
                else {
                    this.setAppCode(res.appcode);
                    this.setAppId(res.appid);
                    this.setError("");
                }
                this.setGenerating(false);
            }
        });
    }
    setError(error) {
        this.error = error;
    }
    setAppCode(code) {
        this.appcode = code;
    }
    setAppId(appid) {
        this.appid = appid;
    }
    setGenerating(gen) {
        this.genertaing = gen;
    }
    setDeviceCode(code) {
        this.devicecode = code;
    }
    setOpen(open) {
        this.open = open;
        this.basedialogState.setOpen(open);
    }
    generateCodes() {
        if (!this.devicecode) {
            return;
        }
        this.setGenerating(true);
        const msg = {
            devicecode: this.devicecode
        };
        Apphandler.sendMessage("registeranotherdevice", msg);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterNewDeviceStore.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterNewDeviceStore.prototype, "devicecode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterNewDeviceStore.prototype, "genertaing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterNewDeviceStore.prototype, "error", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterNewDeviceStore.prototype, "appcode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RegisterNewDeviceStore.prototype, "appid", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterNewDeviceStore.prototype, "setError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterNewDeviceStore.prototype, "setAppCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterNewDeviceStore.prototype, "setAppId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RegisterNewDeviceStore.prototype, "setGenerating", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RegisterNewDeviceStore.prototype, "setDeviceCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RegisterNewDeviceStore.prototype, "setOpen", null);
let RegisterNewDeviceDialog = class RegisterNewDeviceDialog extends React.Component {
    constructor(prop) {
        super(prop);
        this.props.state.basedialogState.onClose = () => this.closed();
    }
    componentWillUnmount() {
        this.props.state.setError("");
        this.props.state.setGenerating(false);
        this.props.state.setDeviceCode("");
        this.props.state.setAppCode("");
        this.props.state.setAppId("");
    }
    closed() {
        const rstore = this.context;
        this.props.state.setOpen(false);
    }
    dialog() {
        const rstore = this.context;
        return (React.createElement(Center, null,
            React.createElement(Box, { mt: '5%', h: testIsMobile() ? (window.innerHeight - 100) + "px" : (window.innerHeight - 150) + "px", className: 'login-container', width: testIsMobile() ? window.innerWidth - 50 + "px" : '600px' },
                React.createElement(FormControl, { id: "devicecode" },
                    React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "New Device Code"),
                    React.createElement(Input, { focusBorderColor: AppColor.HeaderIconColor, onChange: (e) => this.props.state.setDeviceCode(e.currentTarget.value) }),
                    React.createElement(FormHelperText, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "Enter the code from your new device here")),
                this.props.state.appcode !== '' && React.createElement(FormControl, { mt: '15px', id: "devicecode" },
                    React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "APP Code"),
                    React.createElement(Text, null, this.props.state.appcode),
                    React.createElement(FormHelperText, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "APP Code is your secret code that only you know and will help to securely regitser your another device")),
                this.props.state.appcode !== '' && React.createElement(FormControl, { mt: '15px', id: "devicecode" },
                    React.createElement(FormLabel, { style: { color: AppColor.GreetingMessage, fontSize: '12px' } }, "APP Id"),
                    React.createElement(Text, null, this.props.state.appid)),
                !this.props.state.genertaing && React.createElement(Center, { mt: '15px' },
                    React.createElement(Button, { onClick: () => this.props.state.generateCodes(), disabled: this.props.state.devicecode ? false : true, variant: 'unstyled', color: 'red' }, "Generate device register codes")),
                this.props.state.genertaing && React.createElement(Center, { mt: '15px' },
                    React.createElement(ScaleLoader, { color: AppColor.GreetingMessage })),
                this.props.state.error !== "" && React.createElement(Center, { mt: '15px' },
                    React.createElement(Text, { color: 'red', fontWeight: 'bold' }, this.props.state.error)))));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
RegisterNewDeviceDialog.contextType = StoreContext;
RegisterNewDeviceDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RegisterNewDeviceDialog);
export { RegisterNewDeviceDialog };
